export const rules ={
    name: [
    { required: true, message: "请输入名称", trigger: "blur" },
  ],
  type: [
    { required: true, message: "请输入类型", trigger: "blur" },
  ],
 
}